import React from 'react';
export const RadioGroupContext = React.createContext({
    value: null,
    onChange: () => {
        // empty
    },
});
